/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I find the final price after a discount?`)
};

const es_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo hallo el precio final después de un descuento?`)
};

const de_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie finde ich den Endpreis nach einem Rabatt?`)
};

const nl_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe bepaal ik de eindprijs na een korting?`)
};

const fr_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment trouver le prix final après une réduction ?`)
};

const it_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come trovo il prezzo finale dopo uno sconto?`)
};

const pt_br2_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro o preço final depois de um desconto?`)
};

const pt_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro o preço final após um desconto?`)
};

const ja_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割引後の最終価格を求めるには？`)
};

const zh_pct_discount_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何计算折扣后的最终价格？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_faq2_q", locale)
	if (locale === "en") return en_pct_discount_faq2_q(inputs)
	if (locale === "es") return es_pct_discount_faq2_q(inputs)
	if (locale === "de") return de_pct_discount_faq2_q(inputs)
	if (locale === "nl") return nl_pct_discount_faq2_q(inputs)
	if (locale === "fr") return fr_pct_discount_faq2_q(inputs)
	if (locale === "it") return it_pct_discount_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_faq2_q(inputs)
	if (locale === "pt") return pt_pct_discount_faq2_q(inputs)
	if (locale === "ja") return ja_pct_discount_faq2_q(inputs)
	return zh_pct_discount_faq2_q(inputs)
};